// extracted by mini-css-extract-plugin
export var item = "S2nuz";